import { Card, Layout, Space, Tooltip } from 'antd';
import { useAppSelector } from 'app/hooks';
import { BrushIcon, FilterIcon, SideLeftIcon } from 'components/Icons';
import { RevxButton } from 'components/RevxButton';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { SectionHeading } from 'components/RevxTypography';
import { isEmpty } from 'lodash-es';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const { Sider, Content } = Layout;
type Props = {
  children: React.ReactNode;
  header: React.ReactNode;
  filterForm: React.ReactNode;
  modelName: string;
};

export const FilterLayout = ({
  children,
  filterForm,
  header,
  modelName,
}: Props) => {
  const { t } = useTranslation();
  const [siderCollapsed, setSiderCollapsed] = useState(false);
  const filterObj = useAppSelector((state) => state[modelName]?.filterObj);
  const filterForceHidden = useAppSelector(
    (state) => state.app.filterForceHidden
  );

  const filterHandler = () => {
    const filterBtn: HTMLButtonElement = document.querySelector(
      '.admin-filter-btn'
    ) as HTMLButtonElement;
    if (filterBtn) {
      filterBtn.click();
    }
  };

  return (
    <>
      {header}
      <Layout
        style={{ background: 'transparent' }}
        className="platform-filter-layout"
      >
        <Sider
          width={300}
          style={{ padding: '0 15px 0 0' }}
          collapsible
          collapsed={siderCollapsed || filterForceHidden}
          trigger={null}
          hidden={siderCollapsed || filterForceHidden}
        >
          <Card
            hidden={siderCollapsed}
            className="platform-filter-card"
            title={
              <RevxFlexLayout justify="space-between">
                <SectionHeading style={{ margin: 0 }}>
                  {t('platform.filter.title')}
                </SectionHeading>
                <div>
                  <Space
                    size="middle"
                    style={{
                      cursor: 'pointer',
                      color: '#757575',
                      fontSize: 16,
                    }}
                  >
                    <Tooltip
                      title={t('platform.filter.filterBtnLabel')}
                      trigger={['hover', 'click']}
                    >
                      {isEmpty(filterObj) ? (
                        <span onClick={filterHandler}>
                          <FilterIcon style={{ fontSize: 18 }} />
                        </span>
                      ) : (
                        <span onClick={filterHandler}>
                          <FilterIcon style={{ fontSize: 18 }} />
                        </span>
                      )}
                    </Tooltip>
                    <Tooltip
                      title={t('platform.filter.clearFilterBtnLabel')}
                      trigger={['hover', 'click']}
                    >
                      <span
                        onClick={() => {
                          const filterBtn: HTMLButtonElement =
                            document.querySelector(
                              '.admin-clear-filter-btn'
                            ) as HTMLButtonElement;
                          if (filterBtn) {
                            filterBtn.click();
                          }
                        }}
                      >
                        <BrushIcon style={{ fontSize: 19 }} />
                      </span>
                    </Tooltip>
                    <div
                      style={{
                        cursor: 'pointer',
                        color: '#757575',
                        fontSize: 16,
                      }}
                    >
                      <span
                        onClick={() => {
                          setSiderCollapsed(!siderCollapsed);
                        }}
                      >
                        <SideLeftIcon style={{ fontSize: 17 }} />
                      </span>
                    </div>
                  </Space>
                </div>
              </RevxFlexLayout>
            }
            size="small"
          >
            {filterForm}
          </Card>
        </Sider>
        {siderCollapsed && (
          <Tooltip title={t('platform.filter.showFilters')}>
            <RevxButton
              type="primary"
              className="btn-show-filter"
              brandLightPurple
              style={{
                position: 'fixed',
                left: 0,
                top: 204,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                width: 30,
                height: 40,
              }}
              icon={
                <span style={{ color: 'white', verticalAlign: 'middle' }}>
                  <FilterIcon style={{ fontSize: 18 }} />
                </span>
              }
              onClick={() => {
                setSiderCollapsed(!siderCollapsed);
              }}
            ></RevxButton>
          </Tooltip>
        )}
        <Content>{children}</Content>
      </Layout>
    </>
  );
};
